import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Hotel } from "lucide-react";
import { Link } from "react-router-dom";

export default function AccommodationSearchPage() {
  return (
    <div className="container mx-auto flex items-center justify-center py-16">
      <Card className="max-w-2xl text-center">
        <CardHeader>
          <div className="mx-auto bg-primary/10 text-primary p-3 rounded-full w-fit mb-4">
            <Hotel className="h-8 w-8" />
          </div>
          <CardTitle>Accommodation Search is Coming Soon!</CardTitle>
          <CardDescription>
            We're working hard to integrate a powerful search tool that will help you find the perfect hotels, B&Bs, and rentals right next to your swimming spots.
          </CardDescription>
        </CardHeader>
        <CardContent>
          <p className="text-muted-foreground mb-6">
            Soon, you'll be able to book your entire trip without ever leaving the platform.
          </p>
          <Button asChild>
            <Link to="/itinerary">Back to Your Itineraries</Link>
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}
